import React, { useState } from 'react'
import './index.less'
import { Button, Modal, Space } from 'antd'
import classNames from 'classnames'
import ModalClose from '../ModalClose'

type ModalBaseProps = {
    open: boolean
    onCancel: () => void
    wrapClassName?: string
    title?: React.ReactNode
    close?: boolean             // 是否允许右上角的关闭 默认允许
    finish?: () => Promise<any>
    footerCancel?: React.ReactNode        //底部取消按钮文字 默认取消
    footerFinish?: React.ReactNode        //底部保存按钮文字 默认保存
    footerFinishDisabled?: boolean        // 底部保存按钮是否禁用
    footerGap?: number                    //底部菜单距离 默认30
    width?: number
    children?: React.ReactNode
    contentPadding?: string               // 弹框编辑   
    footerTop?: string
    titleBottom?: string
    footer?: boolean                      // 是否显示底部
}

const ModalBase: React.FC<ModalBaseProps> = (props) => {

    const {
        contentPadding = '30px 50px',
        footerTop = '40px',
        titleBottom = '30px',
        width,
        open,
        onCancel,
        wrapClassName,
        title,
        close = true,
        finish,
        footerCancel = '取消',
        footerFinish = '保存',
        footerFinishDisabled = false,
        footerGap = 30,
        footer = true,
        children
    } = props

    const [loading, setLoading] = useState(false)

    return <Modal
        open={open}
        wrapClassName={classNames('modalbase-modal', wrapClassName)}
        onCancel={onCancel}
        footer={
            footer ? <Space align="center" size={footerGap} style={{ display: 'flex', justifyContent: 'center' }}>
                <Button style={{ minWidth: '88px' }} onClick={onCancel}>{footerCancel}</Button>
                <Button disabled={footerFinishDisabled} style={{ minWidth: '88px' }} loading={loading} type="primary" onClick={async () => {
                    setLoading(true)
                    finish?.().finally(() => { setLoading(false) })
                }}>{footerFinish}</Button>
            </Space> : false
        }
        closable={false}
        centered={true}
        style={{
            '--content-padding': contentPadding,
            '--footer-top': footer ? footerTop : '0px',
        } as any}
        width={width}
        maskClosable={false}
        destroyOnClose={true}
    >
        {close && <ModalClose className='modalbase-modal-close' onClose={onCancel} />}
        {title && <p className='modalbase-modal-title' style={{ marginBottom: titleBottom }}>{title}</p>}
        <div className='modalbase-modal-content'>
            {children}
        </div>
    </Modal>
}

export default ModalBase